import axios from 'axios';

const PersonalFilePathService = {
	async fetch() {
		return axios.get('/order/api/personal');
	}
};

export default PersonalFilePathService;